import React, {useState} from "react";
import PropTypes from "prop-types";
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'
import Error from "./Error";


const Step3 = (props) => {
  const [hasNameKanaInputError, setHasNameKanaInputError] = useState(false);
  const [hasNameKanaErrorMessage, setNameKanaInputErrorMessage] = useState('');
  const [member, setMember] = useState(props.defaultMember);

  const onClickNextPage = () => {
    fetch(props.validate_step3_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': props.csrf_token
      },
      body: JSON.stringify({member : member})
    }).then((res) => {
      return res.json();
    }).then((data) => {
      setHasNameKanaInputError(false);
      if (data.status === 200) {
        const form = document.createElement("form");
        form.setAttribute("action", props.move_to_step4_url);
        form.setAttribute("method", "post");
        form.style.display = "none";
        document.body.appendChild(form);

        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'authenticity_token');
        input.setAttribute('value', props.csrf_token);

        form.appendChild(input);
        form.submit();
      } else if(data.status === 400) {
        data.errors.forEach(errorParam => {
          if (errorParam.value === 'name_kana') {
            setNameKanaInputErrorMessage(errorParam.reason);
            setHasNameKanaInputError(true);
          }
        });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  return (
    <div className="page_step3">
      <div className="input_area">
        <p>名前（フリガナ）を入力してください。</p>
        <div className="input_group_area">
          <table>
            <tbody>
            <tr>
              <th>名前（フリガナ）</th>
              <td>
                <Error message={hasNameKanaErrorMessage} hasError={hasNameKanaInputError}/>
                <input type="text" tabIndex="8" id="form_index_8" defaultValue={member.name_kana} className="w100"
                       onChange={e => setMember({...member, name_kana: e.target.value})}/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="input_group_area">
        <ul className="footer_button_area">
          <li><a className="btn_entry next_page" tabIndex="9" id="form_index_9" onClick={onClickNextPage}> 入力内容を確認する </a></li>
        </ul>
      </div>
    </div>
  )
};

Step3.propTypes = {
  defaultMember: PropTypes.object,
  validate_step3_url: PropTypes.string,
  move_to_step4_url: PropTypes.string,
  slickGoto: PropTypes.func,
  csrf_token: PropTypes.string,
};

export default Step3;